import React from 'react'
import { Button, Group, Text } from '@mantine/core'

import { CrFormHandle } from '@/components/Event/CrForm/CrFormStep'
import { AttendeeRole } from '@/constants'

const witnessLabel = (form: CrFormHandle, i: number): string => {
  const attendees = form.values.events_feedbacks?.[i]?.attendees ?? []
  const witness = attendees.find(a => a.role === AttendeeRole.WITNESS)
  return witness?.name || `Witness ${i + 1}`
}

const witnessHasError = (form: CrFormHandle, i: number): boolean =>
  Object.keys(form.errors).some(key => key.startsWith(`events_feedbacks.${i}.`))

// Selects which witness the per-witness steps (Attendance box, Opening, Questioning,
// Closing) are bound to. Hidden for single-witness events. Highlights witnesses with
// validation errors after a failed submit.
export const WitnessSwitcher: React.FC<{
  form: CrFormHandle
  activeWitnessIndex: number
  onChange: (index: number) => void
  canRemoveActiveWitness: boolean
  onRemoveActiveWitness: () => void
}> = ({
  form,
  activeWitnessIndex,
  onChange,
  canRemoveActiveWitness,
  onRemoveActiveWitness,
}) => {
  const count = form.values.events_feedbacks?.length ?? 0

  if (count <= 1) {
    return null
  }

  return (
    <Group spacing="xs" align="center">
      <Text size="sm" fw={600}>
        Witness:
      </Text>
      {Array.from({ length: count }, (_, i) => (
        <Button
          key={i}
          size="xs"
          variant={i === activeWitnessIndex ? 'filled' : 'default'}
          color={witnessHasError(form, i) ? 'red' : 'indigo'}
          type="button"
          onClick={() => onChange(i)}
        >
          {witnessLabel(form, i)}
        </Button>
      ))}
      {activeWitnessIndex > 0 && (
        <Button
          type="button"
          size="xs"
          color="red"
          variant="subtle"
          disabled={!canRemoveActiveWitness}
          title={
            canRemoveActiveWitness
              ? 'Remove witness'
              : 'Witnesses can only be removed before their witness section has started.'
          }
          onClick={onRemoveActiveWitness}
        >
          Remove witness
        </Button>
      )}
    </Group>
  )
}
